module.exports = __webpack_public_path__ + "static/media/wesko_lock.330485c3.png";